
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Site Internet : pourquoi le formulaire plutôt que l’e-mail ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Bien configuré, un formulaire de contact devient même un atout pour une communication efficace avec vos prospects. Surtout, il ne constitue plus une option. Cet article vous explique tout sur cet outil !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Site Internet : pourquoi le formulaire plutôt que l’e-mail ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Bien configuré, un formulaire de contact devient même un atout pour une communication efficace avec vos prospects. Surtout, il ne constitue plus une option. Cet article vous explique tout sur cet outil !",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
